/*
 * 文件EN: repaymentCheck.js,
 * 文件CN: 商户还款-还款查询,
 * 创建时间: Monday, 6th July 2020 3:12:18 pm,
 * 创建人: yeungxsheng,
 * 联系邮箱: 854427332@qq.com,
 */

import * as Models from '@/api/T7/repaymentCheck'

export default {
  namespaced: true,
  actions: {
    // 获取列表
    async getList(ctx, payload) {
      return await Models.getListData(payload).then(res => {
        // return (res && res.status === 200 && res.data) && Promise.resolve(res.data) || Promise.reject(`data: ${null}`)
        return (res && res.status === 200 && res.data)
      })
    },
    async getListSecond(ctx, payload) {
      return await Models.getListDataSecond(payload).then(res => {
        return (res && res.status === 200 && res.data)
      })
    }
  }
}
